import { plannerRuleTargets, type PlannerRule, type SavePlannerRule } from "../plannerRules";
import { plannerRuleKindLabels, type PlannerRuleCatalog } from "../plannerRuleDrafts";

export function PlannerRuleTargets({ rule, catalog }: { rule: SavePlannerRule; catalog: PlannerRuleCatalog }) {
  const targets = plannerRuleTargets(rule.definition as PlannerRule["definition"]);
  const groups: Array<[string, string[]]> = [
    ["작업자", targets.workerIds.map(id => catalog.workers.find(row => row.id === id)?.name ?? `대상 없음 (${id})`)],
    ["프로젝트 전체", targets.projectIds.map(id => catalog.projects.find(row => row.id === id)?.name ?? `대상 없음 (${id})`)],
    ["작업", targets.taskIds.map(id => {
      const task = catalog.tasks.find(row => row.id === id);
      return task ? `${catalog.projects.find(row => row.id === task.projectId)?.name ?? ""} — ${task.name}` : `대상 없음 (${id})`;
    })],
  ];
  return <dl className="planner-rule-facts"><div><dt>규칙</dt><dd>{plannerRuleKindLabels[rule.definition.kind]}</dd></div>
    {groups.filter(([, names]) => names.length).map(([name, names]) => <div key={name}><dt>{name}</dt><dd>{names.join(", ")}</dd></div>)}
  </dl>;
}
